/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MOTOLYNK MARKET API
 * Admin, vendor and store APIs of the MOTOLYNK multi-vendor marketplace.
 * OpenAPI spec version: 1.0.0
 */

export type BlankEnum = typeof BlankEnum[keyof typeof BlankEnum];


export const BlankEnum = {
  '': '',
} as const;
